import React from 'react';
import { cn } from '../../utils/cn';
import { ActionBar } from './ActionBar';

/**
 * In-card section title + optional action toolbar (management screens).
 */
export function PageSectionHeader({ title, description, actions, className }) {
  return (
    <div
      className={cn(
        'flex min-w-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between sm:gap-4',
        className
      )}
    >
      <div className="min-w-0 flex-1">
        <h3 className="text-xl font-black tracking-tight text-slate-900 sm:text-2xl">{title}</h3>
        {description ? (
          <p className="mt-1 text-sm font-medium text-slate-500 sm:text-base">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <ActionBar className="sm:max-w-[min(100%,28rem)] sm:shrink-0">{actions}</ActionBar>
      ) : null}
    </div>
  );
}
